export function initTranslationToggle(): void {
    const spanishButton = document.querySelector<HTMLElement>( '#load-spanish-translation' );
    const englishButton = document.querySelector<HTMLElement>( '#load-english-translation' );
    const spanishTranslations = document.querySelectorAll<HTMLElement>( '.crsc-multilingual-spanish-text' );
    const englishTranslations = document.querySelectorAll<HTMLElement>( '.crsc-multilingual-default-text' );

    if ( englishButton ) {
        englishButton.style.display = 'none';
        spanishButton?.addEventListener( 'click', function() {
            spanishTranslations.forEach( ( el ) => { el.style.display = 'block'; } );
            englishTranslations.forEach( ( el ) => { el.style.display = 'none'; } );
            englishButton.style.display = 'block';
            if ( spanishButton ) spanishButton.style.display = 'none';
        })

        englishButton.addEventListener( 'click', function() {
            spanishTranslations.forEach( ( el ) => { el.style.display = 'none'; } );
            englishTranslations.forEach( ( el ) => { el.style.display = 'block'; } );
            englishButton.style.display = 'none';
            if ( spanishButton ) spanishButton.style.display = 'block';
        })
    }
}
